/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import styled, { css } from 'styled-components';
import Tokens from '@nokia-csf-uxr/freeform-design-tokens';
import { zIndex } from 'components/styles';
import { BORDER_BOX } from 'common';

const {
  SHADOW_SPREAD,
} = Tokens;
const { SHADOW_SPREAD_0 } = SHADOW_SPREAD;

const getShadow = ({ shadowColorOne, shadowColorTwo, shadowSpread }) => css`
    box-shadow: ${SHADOW_SPREAD_0}  ${shadowSpread} ${shadowSpread} ${SHADOW_SPREAD_0} ${shadowColorTwo}, 
    ${SHADOW_SPREAD_0} ${SHADOW_SPREAD_0} ${shadowSpread} ${SHADOW_SPREAD_0} ${shadowColorOne};
  `;

export default {
  Container: styled.div`
    ${BORDER_BOX}
    display: flex;
    flex-direction: column;
    height: 100vh;
    overflow: hidden;
  `,
  Header: styled.div`
    ${BORDER_BOX}
    ${props => getShadow(props.theme)};
    z-index: ${zIndex.APP_HEADER};
    [class^="styles__AppToolbar-"] {
      z-index: ${zIndex.APP_HEADER_TOOLBAR};
    }
  `,
  AppBody: styled.div`
    ${BORDER_BOX}
    position: relative;
    z-index: ${zIndex.APP_BODY};
    ${props => css`direction: ${(props.RTL || props.$rtl || props.rtl) ? 'rtl' : 'ltr'};`}
    display: flex;
    flex: 1;
    overflow-y: auto
  `,
  AppContentWrapper: styled.div`
    ${BORDER_BOX}
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    height: 100%;
    min-height: 100%;
    overflow-y: auto;
  `,
  AppContent: styled.div`
    ${BORDER_BOX}
    flex: 1;
    position: relative;
    padding: ${Tokens.SPACING.SPACING_24} ${Tokens.SPACING.SPACING_24} 0 ${Tokens.SPACING.SPACING_24};
    overflow-x: hidden
  `
};
